package com.appsyde.shared.modules.ticket.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class WriteLockDetailDto(
    val accountUserId: String,
    val displayName: String,
    val expiresAt: String
)

@Serializable
data class AcquireLockResponseDto(
    val ticketId: String,
    val writeLock: WriteLockDetailDto
)

@Serializable
data class LockedByOtherErrorDto(
    val error: String,
    @kotlinx.serialization.SerialName("locked_by_account_user_id") val lockedByAccountUserId: String,
    @kotlinx.serialization.SerialName("locked_by_display_name") val lockedByDisplayName: String,
    @kotlinx.serialization.SerialName("expires_at") val expiresAt: String
)

@Serializable
data class RenewLockResponseDto(
    val ticketId: String,
    val expiresAt: String
)

@Serializable
data class ReleaseLockResponseDto(
    val ticketId: String,
    val changed: Boolean
)
